import { Business } from '@/types/homepage';

// Hidden until operators have real activity labels: only 1 of 24 has any today
export const SHOW_HOMEPAGE_FILTERS = false;

export interface MapLayoutProps {
  businesses: Business[];
  /** Operators inside the current map view, for the list. Defaults to all businesses. */
  visibleBusinesses?: Business[];
  /** Whether the section is scrolled into place, so the map and list can take the wheel on desktop */
  isSearchInPlace?: boolean;
  isLoading?: boolean;
  selectedBusiness?: Business | null;
  onBusinessSelect?: (business: Business | null) => void; 
  mapComponent?: React.ReactNode;
  listComponent?: React.ReactNode;
  className?: string;
  onBoundsChange?: (bounds: any) => void;
  onMapReady?: (map: any) => void;
  externalMapStatus?: {
    state: string;
    lastUpdateTime?: number;
    updateMapStatus?: (updates: any) => void;
  };
  onSearch?: (query: string, coordinates?: [number, number]) => Promise<void>;
  isMobileMapOnly?: boolean;
}

export interface MobileFullscreenControlsProps {
  isMobileFullscreen: boolean;
  showFloatingSearch: boolean;
  hasActiveFilters: boolean;
  onFullscreenToggle: () => void;
  onSearchToggle: () => void;
  onFilterToggle: () => void;
  onSearch?: (query: string, coordinates?: [number, number]) => Promise<void>;
  onCloseSearch: () => void;
}

export interface MobileBusinessOverlayProps {
  selectedBusiness: Business | null;
  showOverlay: boolean;
  businessActivities: any;
  businessesWithCustomAdventures?: Set<string>;
  onClose: () => void;
  onOverlayClick: (e: React.MouseEvent) => void;
}

export interface FilterModalProps {
  isOpen: boolean;
  hasActiveFilters: boolean;
  onClose: () => void;
  onClearFilters: () => void;
}

export interface DesktopSidebarProps {
  listComponent?: React.ReactNode;
  isScrollable?: boolean;
} 